import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";

import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";
import figma from "../../assets/Images/figma.png";

import Slideshow from "../../assets/Slideshow/Slideshow"; 




const Lo1Design = () => {
    const navigate = useNavigate();

    const images = [lowprot1, lowprot2, figma];

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo1-headings">
                <h1>Design Of Concept</h1>
                <p>I have to create a wireframes, lo-fi, hi-fi</p>

                
            </div>

            <div className="line"></div>

            <div className="content-lo1">
                <div className="content-lo1-design">
                    <div className="content-lo1-design-text">
                    {/* <img src={gif2}></img> */}
                        <h1>How did I plan this portfolio</h1>
                        <h2>Low Fidelity</h2>
                        <p>
                            The design process for my portfolio, I started with some basic sketches on my book
                            to visualize the layout and overall concept. After I have asome idea of what I want
                            to make, I discuss with Amer and received a positive feedback to try and make this 
                            website. One of the feedback that I got is to maybe try make a 3D face model on the 
                            homepage to make it captivating for the viewer, and to help my portfolio stand out.
                        </p>
                        <h2>Mid Fidelity</h2>
                        <p>
                            After I'm done with sketching, I tried to make a better design on figma. This step
                            helps me in making this website/ portfolio structured and organized, where I can try
                            moving the layout, colors, to try Interacting with this design.
                        </p>
                        <h2>High Fidelity</h2>
                        <p>
                            For this phase, I try to develop this portfolio website. This involves in translating
                            the visual design into a working digital product using HTML, CSS, Javascript, and React
                        </p>

                        <h1>Logo Design</h1>

                        <h1>3D Poster and Arduino</h1>
                        
                    </div>

                    <div className="content-lo1-design-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo1Design;